import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {defaultPagination} from "../../util/Util"


const LovResultLableTable = ({dataSource, onSelectChange, loading}) => {
    const columns = [
        {title: 'Label', dataIndex: 'lovType', key: 'lovType'}
    ];

    const rowSelection = {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            let urlPath = window.location.pathname;
            let index = urlPath.lastIndexOf('/');
            let result= urlPath.substring(index  + 1);
            if (selectedRowKeys.length > 0) onSelectChange(result + "-" + selectedRows[0].lovType)
        }
    };

    return <Table dataSource={dataSource} loading={loading}
                  columns={columns}  bordered
                  rowKey={record => record.id}
                  rowSelection={rowSelection} pagination={defaultPagination()}
    />
};
LovResultLableTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    compact: PropTypes.bool.isRequired
};

export default LovResultLableTable


// WEBPACK FOOTER //
// ./src/js/lovs/result/LovResultLableTable.js